import styled from 'styled-components';

const ActionPlansCompanyTableWrapper = styled.div`
  margin-top: 8px;

  .ant-table-thead > tr > th {
    padding-top: 0;
    border-bottom: 1px solid var(--line-gray);
  }

  &&&& {
    .ant-table-thead > tr > th,
    .ant-table-tbody > tr > td {
      padding-left: 20px;
      padding-right: 20px;
    }
  }

  .ant-table-thead > tr > th::before {
    display: none !important;
  }

  .ant-table-tbody > tr > td {
    border-bottom: 1px solid var(--line-gray);

    &:first-child {
      border-left: 1px solid var(--line-gray);
    }

    &:last-child {
      border-right: 1px solid var(--line-gray);
    }
  }

  .ant-table-tbody > tr:hover > td,
  .ant-table-tbody > tr > td.ant-table-cell-row-hover {
    background-color: transparent;
  }
`;

export default ActionPlansCompanyTableWrapper;
